<template>
<div class="claim-wrapper">
    <h1 class="text-center mb-5">starScream</h1>
    <p>Choose a day and see a beatiful pic thanks NASA api</p>
</div>
</template>

<script>
export default {
  name: 'Claim',
};
</script>

<style lang="scss" scoped>
.claim-wrapper{
  display: flex;
  margin: 0;
  padding: 30px;
  width: 100%;
  align-items: center;
  flex-direction: column;
  color:yellow;
}
</style>
